import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import './style.scss';

export default class Modal extends Component {

	static childContextTypes = {
    closeBox: PropTypes.func,
  }

  getChildContext() {
    return { closeBox: this.props.onCloseModal };
  }

	constructor(props) {
		super(props)
		this.handleBoxDismiss = this.handleBoxDismiss.bind(this)
		this.state = {
			show: true,
			fixed: false
		}	
	}

	componentDidMount(){
    this.setState({show: this.props.show, fixed: this.props.fixed})
  }

	handleBoxDismiss(){
		if (!this.state.fixed) this.props.onCloseModal();
	}

	render() {

		const styleModal = this.props.styleModal !== undefined ? this.props.styleModal : {};
		return (
			this.state.show ?
				<div className="box__wrap">
					<div className="box__over" onClick={this.handleBoxDismiss}></div>
					<div className="box__main" style={styleModal} >
            { this.props.title ? 
							<div className="box_header">
	                { !this.state.fixed ? <div className="box_header_close" onClick={this.handleBoxDismiss}></div> : ''}
	                <div className="box_title">{this.props.title}</div>
	            </div>
	          : !this.state.fixed ? <div className="box_header_close box_header_close_b" onClick={this.handleBoxDismiss}></div> : ''
	        	}
	          <div className="box_body">
							{this.props.children}
						</div>
						{ this.props.footer ? 
							<div className="box_controls_wrap">
	              <div className="box_controls clearfix">
	              	{ this.props.closeButton ? 
		                <div className="fl_r">
		                	<button className="flat_button box_close_button" onClick={this.handleBoxDismiss}>Закрыть</button>
		                </div>
	                : '' }
	                { this.props.save ? <Footer /> : '' }
	              </div>
	            </div>
	           : '' }
					</div>
				</div>
				: null
		)
  }
}

export class ModalContainer extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
    this.modal = document.getElementById('modal-container');
  }

  componentDidMount() {
    this.modal.appendChild(this.el);
  }

  componentWillUnmount() {
    this.modal.removeChild(this.el);
  }
  
  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}


export class Footer extends Component {
	render() {
		return (
			this.props.children
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/modal/index.js